import script from "./TaskView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskView.vue?vue&type=script&setup=true&lang=ts"

import "./TaskView.vue?vue&type=style&index=0&id=4797bfae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4797bfae"]])

export default __exports__